import { render, staticRenderFns } from "./Mt5DashboardMock.vue?vue&type=template&id=902525ba&scoped=true"
import script from "./Mt5DashboardMock.vue?vue&type=script&lang=js"
export * from "./Mt5DashboardMock.vue?vue&type=script&lang=js"
import style0 from "./Mt5DashboardMock.vue?vue&type=style&index=0&id=902525ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902525ba",
  null
  
)

export default component.exports